<template>
  <v-app>
    <v-content>
      <router-view />
    </v-content>
    <confirm-dialog ref="confirm"></confirm-dialog>
    <snackbar ref="snackbar"></snackbar>
    <progressbar ref="progressbar"></progressbar>
    <!-- <a v-if="this.$route.path != '/welcome'" href="/acadsocim.html"
       style='position:fixed;bottom:100px;right:100px;width:50px;height:50px;border-radius:50%;background:green;display:block'
       target="_blank">
      <img src='./assets/img/common/Group_message1.png'
           alt=''
           style='width:100%;height:100%;display:block'></a> -->
  </v-app>
</template>

<script>
import confirmDialog from '@/components/confirmDialog'
import snackbar from '@/components/snackbar'
import progressbar from '@/components/dialogs/progressbar'
export default {
  name: 'App',
  components: {
    confirmDialog,
    snackbar,
    progressbar
  },
  mounted () {
    // 注册全局confirm
    this.$root.$confirm = this.$refs.confirm.open
    // 注册全局snackbar
    this.$root.$snackbar = this.$refs.snackbar.show
    // 注册全局alert
    this.$root.$alert = (msg, alertType, options) => {
      return this.$refs.confirm.open(msg, alertType, Object.assign({}, {
        persistent: true,
        cancelBtn: {
          display: false
        },
        confirmBtn: {
          display: true,
          color: '#3e67fb'
        },
        icon: {
          default: false
        }
      }, options))
    }
    this.$root.$alertTips = (msg, alertType, options) => { // 以alertType 区分message类型， 1. 默认为error 消息不自动关闭  2. success 成功为弱类型提示，3秒后自动消失
      return this.$root.$alert(msg, alertType, options)
    }
    // 全局注册progressbar
    this.$root.$progressbar  = this.$refs.progressbar
    // this.$root.$progressbarClose  = this.$refs.progressbar.cancel
    // this.$root.$progressbarCancelRegister = this.$refs.progressbar.registerEvent
  },
  created () {
    let loading = document.getElementById('Loading')
    if (loading != null) document.body.removeChild(loading)
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>
<style>
.to-IM-system {
  position: fixed;
  right: 3%;
  bottom: 22%;
  text-decoration: none;
}
</style>
